module.exports = __webpack_public_path__ + "files/1e1ad99b460659bd2ddee339d8791f32.png";